import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUsersInHeadquarter } from "../helpers/requests";

interface RemoteStartModalProps {
  setShowModal: (show: boolean) => void;
  onConfirm: (userId: string, logoutAfterTraining: boolean) => void;
  headquarterId: string;
}

const RemoteStartModal: React.FC<RemoteStartModalProps> = ({
  setShowModal,
  onConfirm,
  headquarterId,
}) => {
  const { t } = useTranslation();
  const [users, setUsers] = useState<any[]>([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [logoutAfterTraining, setLogoutAfterTraining] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      if (!headquarterId) return;
      setIsLoading(true);
      try {
        const userData = await getUsersInHeadquarter(headquarterId);
        setUsers(userData);
      } catch (error) {
        console.error("Error fetching users for remote start:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, [headquarterId]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!selectedUserId) return;
    onConfirm(selectedUserId, logoutAfterTraining);
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div style={{ textAlign: "center", fontSize: "1.3em" }}>
          {t("Remote_Start_Configuration")}
        </div>
        <form onSubmit={handleSubmit} className="m-4">
          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label style={{ marginLeft: "20px", color: "#404040", fontWeight: "bold" }}>{t("User")}</label>
            <select
              className="form-control"
              value={selectedUserId}
              onChange={(e) => setSelectedUserId(e.target.value)}
              required
              style={{ backgroundColor: "#CCCCCC", borderRadius: "20px", color: "#404040", height: "5vh", maxHeight: "40px", fontSize: "1em", paddingLeft: "20px" }}
            >
              <option value="" disabled hidden>
                  {t("Select_User")}
              </option>
              {users.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.firstName} {u.lastName} ({u.email})
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3 form-check custom-checkbox" style={{ marginTop: "2vh" }}>
            <label className="custom-checkbox-label">
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={logoutAfterTraining}
                    onChange={(e) => setLogoutAfterTraining(e.target.checked)}
                />
                <span className="checkmark"></span>
                <span className="form-check-label">{t("Logout_after_each_training")}</span>
            </label>
          </div>

          <div className="button-container">
            <button
              type="button"
              className="buttonCancel btn btn-primary"
              onClick={() => setShowModal(false)}
            >
              {t("Cancel")}
            </button>
            <button
              type="submit"
              className="btn btn-primary buttonAcceptGreen"
              disabled={isLoading || !selectedUserId}
            >
              {t("Start")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RemoteStartModal;
